var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('floob-header',{attrs:{"title":'리포트'}}),_c('floob-report',{attrs:{"hideHeader":true}}),_c('div',{staticClass:"pa-12"}),(_vm.$vuetify.breakpoint.smAndUp)?_c('floob-footer',{attrs:{"fixed":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }